module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newDy"
  }, [_c('div', {
    staticClass: "nd-topitem"
  }, [_c('div', {
    staticClass: "nd-screenTop"
  }, [_c('div', {
    staticClass: "topcenter"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "address"
  }, [_c('el-button', {
    staticClass: "nd-selectBtn",
    attrs: {
      "type": "text"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.selectCity('新闻动态')
      }
    }
  }, [_vm._v("新闻动态")]), _vm._v(" "), _c('el-button', {
    staticClass: "nd-noSelectBtn",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "text"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.selectCity('联系我们')
      }
    }
  }, [_vm._v("联系我们")]), _vm._v(" "), _c('el-button', {
    staticClass: "nd-noSelectBtn",
    attrs: {
      "type": "text"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.selectCity('产品介绍')
      }
    }
  }, [_vm._v("产品介绍")]), _vm._v(" "), _c('el-button', {
    staticClass: "nd-noSelectBtn",
    attrs: {
      "type": "text"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.selectCity('首页')
      }
    }
  }, [_vm._v("首页")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "newdetial-center clearfix"
  }, [_c('div', {
    staticClass: "newdetial-center-top clearfix"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "newdetial-center-top-right clearfix",
    on: {
      "click": _vm.back
    }
  }, [_vm._v("\n            返回上一层 →\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "newdetial-center-title"
  }, [_vm._v("\n          我市成功举办首届数字经济创新创业大赛\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "newdetial-center-titleLine"
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('div', {
    staticClass: "screen-6",
    staticStyle: {
      "height": "300px",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "page-bottom clearfix"
  }, [_c('div', {
    staticClass: "page-content-container clearfix"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "page-bottom-right clearfix"
  }, [_c('div', {
    staticClass: "page-bottom-right-content"
  }, [_c('div', {
    staticClass: "page-bottom-content-list"
  }, [_c('span', {
    staticClass: "page-bottom-content-item",
    on: {
      "click": function($event) {
        return _vm.selectCity('首页')
      }
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('span', {
    staticClass: "page-bottom-content-item",
    on: {
      "click": function($event) {
        return _vm.selectCity('产品介绍')
      }
    }
  }, [_vm._v("产品介绍")]), _vm._v(" "), _c('span', {
    staticClass: "page-bottom-content-item",
    on: {
      "click": function($event) {
        return _vm.selectCity('联系我们')
      }
    }
  }, [_vm._v("联系我们")]), _vm._v(" "), _c('span', {
    staticClass: "page-bottom-content-item",
    on: {
      "click": function($event) {
        return _vm.selectCity('新闻动态')
      }
    }
  }, [_vm._v("新闻动态")]), _vm._v(">\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "page-bottom-hor-split"
  }), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8)]), _vm._v(" "), _vm._m(9)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topImage"
  }, [_c('img', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "src": require("@/assets/mainlogo.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topRight1"
  }, [_c('div', {
    staticClass: "topRight1T"
  }, [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("业务咨询")])]), _vm._v(" "), _c('div', {
    staticClass: "topRight1B"
  }, [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("0536-8812347")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "float": "right",
      "margin-right": "8px"
    },
    attrs: {
      "src": require("@/assets/topphone.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newdetial-center-top-center clearfix"
  }, [_c('div', {
    staticStyle: {
      "font-size": "40px",
      "margin-top": "26px",
      "color": "white"
    }
  }, [_vm._v("\n              27\n            ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "18px",
      "color": "white"
    }
  }, [_vm._v("\n              2018/7\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newdetial-center-text"
  }, [_c('p', {
    staticStyle: {
      "text-indent": "2em"
    }
  }, [_vm._v("\n            2018年7月26日，“数动潍坊”——潍坊市首届数字经济创新创业大赛在潍坊总部基地大数据双创中心顺利举办。市委政研室（改革办）四级调研员孟志刚，市智慧办副主任胡延年，市人力资源管理中心副主任、潍坊创业大学校长孙友欣，潍坊金融控股集团党委副书记张振江出席大赛。")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "2em"
    }
  }, [_vm._v("本届数字经济创新创业大赛是我市第五届创业大赛的重要内容，由市智慧办会同市活力办、市人社局共同主办，潍坊市大数据交易中心具体承办。旨在培养全民参与大数据创新创业意识，提升创新创业能力，鼓励企业及创业团队（个人）基于省、市公共数据开放网等资源，发掘具有较强竞争力和发展潜力的大数据、云计算、物联网、人工智能等创新创业项目，助推我市数字经济蓬勃发展，并为全市新旧动能转换工作和“四个城市”建设增添活力。")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "2em"
    }
  }, [_vm._v("大赛采用项目路演形式，分企业和团队（个人）两个赛道进行比赛，共有25家企业、9个团队（个人）项目参加角逐。经省市两级相关专家现场评审，并按项目成熟度、创新性、可操作性等指标当场亮分，实时公布比赛排名，最终“V派——城市通行证”，“‘潍V’民生综合服务平台”、“婚嫁产业大数据平台开发与共生模式建设”，“企业征信——金融服务一贷通解决方案”、“悦帮管家——基于区块链的去中心化综合服务平台”、“生鲜果蔬电商”等项目分获企业组一二三名；“旅游大数据精准营销平台”，“应急指挥调度平台”、“基于区块链技术的全域智慧旅游平台”，“花多采——花卉产业链专业服务平台”、“智慧昌乐公共信息平台”、“惠群公社”分获团队（个人）组一二三名。\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newdetial-center-image"
  }, [_c('img', {
    staticStyle: {
      "width": "959px",
      "height": "564px"
    },
    attrs: {
      "src": require("@/assets/detial1.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-bottom-left"
  }, [_c('img', {
    staticClass: "page-bottom-left-logo",
    attrs: {
      "src": require("@/assets/mainlogo.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("公司致力于智慧城市便民服务体系建设和运营，以“V派”城市通行证手机APP为载体，依托云计算、物联网、大数据应用和“互联网+”技术，以创建全国智慧城市样板为目标，逐步提升城市公共服务水平和居民生活品质。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-bottom-company-detail"
  }, [_c('img', {
    staticClass: "page-bottom-company-detail-icon",
    attrs: {
      "src": require("@/assets/gw_address_icon.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("山东省潍坊市奎文区恒易宝莲金融中心A座1902")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-bottom-company-detail"
  }, [_c('img', {
    staticClass: "page-bottom-company-detail-icon",
    attrs: {
      "src": require("@/assets/gw_tel_icon.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("0536-8812347")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-bottom-company-detail"
  }, [_c('img', {
    staticClass: "page-bottom-company-detail-icon",
    attrs: {
      "src": require("@/assets/gw_mail_icon.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("icloudpay@icloudpay.net.cn")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-bottom-right-code-container"
  }, [_c('img', {
    staticClass: "qrcode",
    attrs: {
      "src": require("@/assets/gw_qrcode.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("扫一扫关注我们")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-4cb9c4d0"}!./~/_vux-loader@1.2.9@vux-loader/src/before-template-compiler-loader.js!./~/_vux-loader@1.2.9@vux-loader/src/template-loader.js!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/Guanwang/newdetial1.vue
// module id = 292
// module chunks = 1